import React from 'react';
import '../../styles/legal.css';

const RefundPolicy = () => {
    return (
        <div className="legal-container">
            <div className="legal-header">
                <h1 className="legal-title">Refund & Return Policy</h1>
                <p className="legal-meta">Last Updated: June 3, 2026</p>
            </div>

            <div className="legal-section">
                <h2>1. General Billing Terms</h2>
                <p>
                    SIE QR Menu operates as a digital Software-as-a-Service (SaaS) platform provided by <strong>Search is End!</strong> 
                    (legally registered under proprietary firm <strong>Smart City Ajmer</strong>, GSTIN: 08ANVPS9429D1Z8). 
                </p>
                <p>
                    All subscriptions (monthly and yearly tiers) are billed on a recurring cycle in advance of service delivery.
                </p>
            </div>

            <div className="legal-section">
                <h2>2. Strictly Non-Refundable Policy</h2>
                <div className="legal-alert">
                    <p>
                        All subscription payments made to Smart City Ajmer (Search is End!) for using SIE QR Menu 
                        are strictly <strong>non-refundable</strong>. 
                    </p>
                </div>
                <p>
                    Due to the immediate provisioning of resources (including custom subdomain menu hosting, instant QR code generation templates, 
                    database allocation, automated push notification pipelines, and AI scanning feature access), we do not offer refunds, 
                    credits, or prorated adjustments for partially used cycles, unused accounts, or client-side operational issues.
                </p>
            </div>

            <div className="legal-section">
                <h2>3. Evaluate Before You Buy (Free Trial)</h2>
                <p>
                    To ensure SIE QR Menu fits your restaurant's workflow, we offer a risk-free Trial Period. 
                    During the trial, you can configure your menu, print QR codes, test waitstaff KOT views, and explore the admin dashboard. 
                    We strongly encourage you to thoroughly evaluate the Platform during the trial period before initiating a paid subscription.
                </p>
            </div>

            <div className="legal-section">
                <h2>4. Subscription Cancellation</h2>
                <p>
                    You can cancel your subscription plan at any time:
                </p>
                <ul>
                    <li>Upon cancellation, your subscription will remain active, and you will retain full access to the admin dashboard and your public digital menu until the end of your current paid billing period.</li>
                    <li>No further recurring payments will be charged after cancellation.</li>
                    <li>We do not refund the remaining days of your active billing cycle after you cancel.</li>
                </ul>
            </div>

            <div className="legal-section">
                <h2>5. Setup Fees & Hardware Returns</h2>
                <p>
                    SIE QR Menu is an entirely digital SaaS platform. 
                </p>
                <ul>
                    <li><strong>No Setup Fees:</strong> We do not charge database installation, account initialization, or onboarding setup fees.</li>
                    <li><strong>No Physical Goods:</strong> We do not supply or ship physical hardware (such as printers, tablets, or acrylic QR frames). Consequently, there are no return shipping processes, restocking fees, or physical returns managed by our team.</li>
                </ul>
            </div>

            <div className="legal-section">
                <h2>6. Sponsor & Advertiser Wallet Deposits</h2>
                <p>
                    For businesses utilizing the SIE QR Menu Advertising Network (Sponsor Portal):
                </p>
                <ul>
                    <li><strong>Pre-paid Wallet:</strong> All ad campaigns operate on a pre-paid wallet system. Funds deposited into your sponsor wallet are strictly non-refundable and cannot be withdrawn.</li>
                    <li><strong>Campaign Rejection:</strong> If your ad campaign is rejected during the review process, no funds are deducted from your wallet for that campaign. However, the deposited wallet balance remains non-refundable.</li>
                    <li><strong>GST Disclaimer:</strong> All wallet deposits and ad network charges are subject to 18% GST as per Indian regulations. <strong>GST paid on wallet deposits is strictly non-refundable under any circumstances.</strong></li>
                </ul>
            </div>

            <div className="legal-section">
                <h2>7. Billing Inquiries & Disputes</h2>
                <p>
                    If you believe you have been billed in error or need assistance with billing adjustments, please email us directly 
                    at <a href="mailto:searchisend@smartcityajmer.com">searchisend@smartcityajmer.com</a> within 15 days of the transaction date. 
                    We will review your inquiry and work with you to resolve it.
                </p>
            </div>

            <div className="legal-contact-box">
                <h3>Contact & Company Details</h3>
                <p><strong>Operating Brand:</strong> Search is End!</p>
                <p><strong>Registered Proprietorship:</strong> Smart City Ajmer</p>
                <p><strong>GST Number:</strong> 08ANVPS9429D1Z8</p>
                <p><strong>Support & Legal Email:</strong> <a href="mailto:searchisend@smartcityajmer.com">searchisend@smartcityajmer.com</a></p>
                <p><strong>Mailing Address:</strong> Registered address of Smart City Ajmer (Ajmer, Rajasthan, India).</p>
                <p style={{ fontSize: '0.85em', color: '#64748b', marginTop: '15px' }}>
                    <em>Disclaimer: If the registered physical address of Smart City Ajmer is updated, this mailing address is deemed updated in tandem. 
                    For the latest active registered address, please verify the registration certificate on the official Smart City Ajmer website.</em>
                </p>
            </div>
        </div>
    );
};

export default RefundPolicy;
